import {Component, Input, OnInit} from '@angular/core';
import {EmailStatesMapCache} from '../../model/model-map-cache';
import {combineLatest} from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-email-state-label',
  templateUrl: './email-state-label.component.html',
  styleUrls: ['./email-state-label.component.scss']
})
export class EmailStateLabelComponent implements OnInit {

  @Input()
  emailStateId: number;

  vm$;

  constructor(private cache: EmailStatesMapCache) {
  }

  ngOnInit() {
    this.vm$ = combineLatest([
      this.cache.map$
    ]).pipe(
      map(([states]) => ({states}))
    );
  }

}
